import script from "./ProgramsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsView.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsView.vue?vue&type=style&index=0&id=21985a47&lang=scss&scoped=true"
import "./ProgramsView.vue?vue&type=style&index=1&id=21985a47&lang=css"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21985a47"]])

export default __exports__